import Delegate from 'ftdomdelegate';
import Stickyfill from 'stickyfilljs';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js'
import 'photoswipe/dist/photoswipe.css'

import Carousel from '../components/carousel';
import ProductVariants from '../components/product-variants';
import OverflowScroller from '../tools/overflow-scroller';
import ScrollSpy from '../tools/scroll-spy';
import Dom from '../tools/dom';
import Responsive from '../tools/responsive';
import VideoSection from '../components/video-section';

export default class ProductSection {
  constructor(container) {
    let _this1 = this;

    this.element = container;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    
    var stackImages = document.querySelectorAll('.product__gallery--stack .carousel .carousel__cell');
    this.tabNavCarousels = []
    this.tabPanesCarousels = []
    
    if (this.options['templateSuffix'] !== 'coming-soon') {
      this.productVariants = new ProductVariants(container, this.options);
    }

    let productSlideshowElement = this.element.querySelector('.product__slideshow');

    // If there is no image at all, there is nothing to init
    if (productSlideshowElement) {
      this.productSlideshow = new Carousel(productSlideshowElement, { 
        onSelect: this._onImageChanged.bind(this),
        onClick:this._onImageClick.bind(this)
      });

      if (this.options['stackProductImages']) {
        this.slideshowNavDots = this.element.querySelector('.product__slideshowNav--dots');
        this.slideshowNavDotsItems = this.slideshowNavDots ? Dom.nodeListToArray(this.slideshowNavDots.querySelectorAll('a')) : [];
        stackImages.forEach((item,index)=>{
          item.addEventListener('click',()=>{
            if(item.hasAttribute('data-image-position-ignoring-video')){
              this._photoSwipeFull(index);
            }
            else{
              console.log('Not a image');
            }
          })
        });

        function isInViewPort(element, index) {
            // Get the bounding client rectangle position in the viewport
            var bounding = element.getBoundingClientRect();
            // Checking part. Here the code checks if it's *fully* visible
            if (bounding.top <= 200 && bounding.bottom >= 100 ) {
                return true;
            } else {
                return false;
            }
        }
        window.addEventListener('scroll', function (event) {
          var navImages = this.document.querySelectorAll('.product__gallery--stack .product__slideshowNavScroller a');
              stackImages.forEach((item,index)=>{
                if (isInViewPort(item, index)) {
                  item.classList.add('is-selected');
                  navImages[index].classList.add('is-selected');
                }

                else {
                  item.classList.remove('is-selected');
                  navImages[index].classList.remove('is-selected');
                }
              });
        }, false);
      }

      if (this.options['showThumbnails']) {
        this.slideshowNavThumbnails = this.element.querySelector('.product__slideshowNav--thumbnails');
        this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails ? Dom.nodeListToArray(this.slideshowNavThumbnails.querySelectorAll('.product__slideshowNavImage')) : [];
      }

      this.slideshowImages = Dom.nodeListToArray(productSlideshowElement.querySelectorAll('.carousel__cell'));
    }

    this.productWrapperElement = this.element.querySelector('.product__wrapper');
    this.productInfoElement = this.element.querySelector('.product__info');
    this.productAsideElement = this.element.querySelector('.product__aside');
    this.productGalleryElement = this.element.querySelector('.product__gallery');
    this.quickNav = this.element.querySelector('.product__quickNav');

    if (this.options['enableImageZoom']) {
      // this.imageZoomInstance = new __WEBPACK_IMPORTED_MODULE_2__components_ProductImageZoom__["default"](this.element, this.productSlideshow);
    }

    Stickyfill.addOne(this.productInfoElement);
    
    // We initialited without checking the device size because flickity was having trouble with adaptive height for nested slider.
    Dom.nodeListToArray(this.element.querySelectorAll('.product__tabPanes')).forEach(function (item) {
      _this1.tabPanesCarousels.push(new Carousel(item))
    })
    Dom.nodeListToArray(this.element.querySelectorAll('.product__tabNav')).forEach(function (item) {
      _this1.tabNavCarousels.push(new Carousel(item))
    })

    let productVideosTab = this.element.querySelector('.product__tabContent--videos');
    // If there is no videos tab there is nothing to init
    if(productVideosTab) {
      new VideoSection(productVideosTab)


    }
    this._setupDeviceFeatures();
    this._attachListeners();
  }
  onUnload() {
    this.delegateElement.off('click');

    if (this.productVariants) {
      this.productVariants.destroy();
    }

    if (this.productSlideshow) {
      this.productSlideshow.destroy();
    }

    this.tabNavCarousels.map(item =>
      item.destroy()  
    )

    this.tabPanesCarousels.map(item =>
      item.destroy()  
    )

    if (this.carouselNavScrollSpy) {
      this.carouselNavScrollSpy.destroy();
    }

    if (this.quickNav) {
      window.removeEventListener('scroll', this._checkQuickNavListener);
    }

    if (this.productInfoScroller) {
      this.productInfoScroller.destroy();
    }

    if (this.productThumbnailsScroller) {
      this.productThumbnailsScroller.destroy();
    }

    if (window.ResizeObserver && this.productInfoResizeObserver) {
      this.productInfoResizeObserver.disconnect();
    }

    Stickyfill.removeOne(this.productInfoElement);

    document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
  }
  _attachListeners() {
    this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this);
    this._checkQuickNavListener = this._checkQuickNav.bind(this);

    this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
    this.delegateElement.on('scrollspy:target:changed', this._onScrollTargetChanged.bind(this));

    document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);

    if (this.quickNav) {
      window.addEventListener('scroll', this._checkQuickNavListener);
    }

    if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
      this.delegateElement.on('click', '.product__slideshowNavImage', this._switchToImage.bind(this));
    }
  }

  /**
   * Update the main carousel image
   */

  _updateSlideshowImage(event) {
    let variant = event.detail.variant,
        previousVariant = event.detail.previousVariant;
    if (!variant || !variant['featured_image'] || previousVariant && previousVariant['featured_image'] && previousVariant['featured_image']['id'] === variant['featured_image']['id']) {
      return;
    }

    // Using image['position'] has always been unreliable. Further more in this theme we allow some images to be featured and not be part of
    // the main carousel, so the position can be simply wrong.
    // We have two logic here: if we are on pocket mode, we switch using the carousel, otherwise we simulate a link to the anchor

    if (Responsive.matchesBreakpoint('pocket') || !this.options['stackProductImages']) {
      for (let i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
        let cellElement = this.productSlideshow.flickityInstance.cells[i].element,
            imageId = parseInt(cellElement.getAttribute('data-image-id'));
        if (imageId === variant['featured_image']['id']) {
          this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-image-position')));
        }
      }
    } else {
      var variantImageID = variant['featured_image']['id'];
      var variantImagehref = '#Image' + variantImageID;  
      var withref = 'href="'+ variantImagehref+'"';
      document.querySelector("["+withref+"]").click();
      // document.getElementById(`Image${variant['featured_image']['id']}`).scrollIntoView(); 
      //For now there is a bug in Chrome that prevents to use this
    }
  }

  /**
   * Callback when the target changes
   */

  _onScrollTargetChanged(event) {
    // The scrollspy emit also an "oldTarget", but when scrolling very fast with Firefox or Safari, it prevents the old to be removed, so we
    // manually iterate through all of them to remove it first
    if (this.options['stackProductImages']) {
      this.slideshowNavDotsItems.forEach(function (item) {
        return item.classList.remove('is-selected');
      });
      this.slideshowNavDotsItems[parseInt(event.detail.newTarget.getAttribute('data-image-position'))].classList.add('is-selected');

      if (this.options['showThumbnails']) {
        this.slideshowNavThumbnailsItems.forEach(function (item) {
          return item.classList.remove('is-selected');
        });
        this.slideshowNavThumbnailsItems[parseInt(event.detail.newTarget.getAttribute('data-image-position'))].classList.add('is-selected');
      }
      console.log(event);
    }
  }
  _switchToImage(event, target) {
    for (let i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
      let cellElement = this.productSlideshow.flickityInstance.cells[i].element,
          imageId = parseInt(cellElement.getAttribute('data-image-id'));

      if (imageId === parseInt(target.getAttribute('data-image-id'))) {
        this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-image-position')));
      }
    }
  }

  /**
   * Check the quick nav
   */

  _checkQuickNav() {
    let _this53 = this;

    let showAsideQuickNav = false;

    fastdom.measure(function () {
      showAsideQuickNav = window.scrollY >= _this53.productAsideElement.offsetTop - _this53.productAsideElement.clientHeight;
    });

    fastdom.mutate(function () {
      if (showAsideQuickNav) {
        _this53.quickNav.classList.add('is-flipped');
      } else {
        _this53.quickNav.classList.remove('is-flipped');
      }
    });
  }

  _onImageChanged(event, cell) {
    // If cell is video, we hide the action list
    if (Responsive.matchesBreakpoint('pocket')) {
      let productGalleryActionListElement = this.element.querySelector('.product__gallery .product__actionList');

      if (productGalleryActionListElement) {
        if (cell.classList.contains('product__slideItem--video')) {
          productGalleryActionListElement.classList.add('hidden');
        } else {
          productGalleryActionListElement.classList.remove('hidden');
        }
      }
    }


    // If we have non-stacked with thumbnails, update it
    if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
      let imageId = cell.getAttribute('data-image-id');

      this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
        if (thumbnail.getAttribute('data-image-id') === imageId) {
          thumbnail.classList.add('is-selected');
        } else {
          thumbnail.classList.remove('is-selected');
        }
      });
    }
  }

  _photoSwipeFull(index){

      const gallery = new PhotoSwipeLightbox({
        gallery: '.product__slideshow',
        children: '.product-image-wrapper-img',
        showHideAnimationType: 'zoom',
        showAnimationDuration: 200,
        hideAnimationDuration: 200,
        pswpModule: () => import('photoswipe/dist/photoswipe.esm.js')
      });
      gallery.init();
  }
  _onImageClick(cell, index) {
    if(cell){
      this._photoSwipeFull(index);
    }
  }

  /**
   * Verify when the screen size changes to create additional stuff on non pocket mode
   */

  _setupDeviceFeatures(event) {
    let _this54 = this;

    let currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
    previousBreakpoint = event ? event.detail.previousBreakpoint : null;

    if (currentBreakpoint === previousBreakpoint) {
      return; // Nothing has changed, no specific setup to do
    }

    if (currentBreakpoint === 'phone' || currentBreakpoint === 'sm' || currentBreakpoint === 'md') {
      if (this.carouselNavScrollSpy) {
        this.carouselNavScrollSpy.destroy();
      }

      if (this.productInfoScroller) {
        this.productInfoScroller.destroy();
      }

      if (this.productThumbnailsScroller) {
        this.productThumbnailsScroller.destroy();
      }

      this.tabNavCarousels.map(item =>
        item.destroy()  
      )

      this.tabPanesCarousels.map(item =>
        item.destroy()  
      )

      if (this.productAsideElement) {
        this.productAsideElement.style.minHeight = null;
      } else {
        this.productWrapperElement.style.minHeight = null;
      }

      this.productInfoElement.parentNode.style.maxHeight = null;
    } else {
      Dom.nodeListToArray(this.element.querySelectorAll('.product__tabPanes')).forEach(function (item) {
        _this54.tabPanesCarousels.push(new Carousel(item))
      })
      Dom.nodeListToArray(this.element.querySelectorAll('.product__tabNav')).forEach(function (item) {
        _this54.tabNavCarousels.push(new Carousel(item))
      })
      // 1st: scrollspy for the dots and image
      if (this.slideshowImages && this.slideshowImages.length > 1) {
        let offsetTop = 0;

        if (this.options['stackProductImages'] && this.slideshowNavDots) {
          offsetTop = this.slideshowNavDots.firstElementChild.offsetTop;
        }

        if (this.options['showThumbnails'] && Responsive.matchesBreakpoint('lg')) {
          offsetTop = 250;
        }

        this.carouselNavScrollSpy = new ScrollSpy(this.element, this.slideshowImages, {
          rootMargin: '-' + offsetTop + 'px 0px 0px 0px'
        });
      }

      let productInfoStyles = window.getComputedStyle(this.productInfoElement),
          productInfoPadding = parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom),
          productGalleryHeight = this.productGalleryElement ? parseInt(this.productGalleryElement.scrollHeight) : 0;

      // 2nd: making sure to set up enough space in aside part
      let calculateMinHeight = function calculateMinHeight() {
        if (_this54.productAsideElement) {
          _this54.productAsideElement.style.minHeight = _this54.productInfoElement.scrollHeight - productInfoPadding - productGalleryHeight + 'px';
          _this54.productInfoElement.closest('.product__infoWrapper').style.maxHeight = _this54.productAsideElement.offsetTop + _this54.productInfoElement.scrollHeight - productInfoPadding + 'px';
        } else {
          _this54.productWrapperElement.style.minHeight = _this54.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop) + 'px';
        }
      };

      calculateMinHeight();

      // This code actually works well, but if a merchant is using an app that dynamically adds content (such as ReCharge or any other widget-based app), this
      // will mess the min height. There is a clean solution to this issue, which is by using ResizeObserver. However it's only supported in Chrome for now,
      // but I feel it's already good to have a clean fix
      if (window.ResizeObserver) {
        this.productInfoResizeObserver = new ResizeObserver(function () {
          calculateMinHeight(); // We currently do not take advantage of the values returned by the observer as our calculation depends on other values
        });

        this.productInfoResizeObserver.observe(this.productInfoElement);
      }

      // 3rd: let's handle the scroll for the product info
      this.productInfoScroller = new OverflowScroller(this.productInfoElement);

      // 4th: let's handle the scroll for the thumbnails
      if (this.options['showThumbnails'] && this.slideshowNavThumbnails) {
        this.productThumbnailsScroller = new OverflowScroller(this.slideshowNavThumbnails);
      }
    }
  }
}